import { createFileRoute } from '@tanstack/react-router';
import { SquareCheck } from 'lucide-react';
import { topic } from '@regent/realtime';
import { Page } from '@/features/shell/page';
import { useTaskDetail } from '@/features/tasks/api';
import { TaskDetail } from '@/features/tasks/task-detail';
import { useTopic, useViewing } from '@/lib/realtime';

export const Route = createFileRoute('/w/$workspaceId/t/$taskId')({ component: TaskPage });

/** Full page task view (the same content as the side panel, with more room). */
function TaskPage() {
  const { taskId } = Route.useParams();
  const { data: task } = useTaskDetail(taskId);
  useTopic(topic.task(taskId));
  useViewing(`task:${taskId}`);
  return (
    <Page title={task?.name ?? 'Task'} icon={<SquareCheck />} scroll={false}>
      <TaskDetail key={taskId} taskId={taskId} mode="page" />
    </Page>
  );
}
